import { render, staticRenderFns } from "./QuitPageDialog.vue?vue&type=template&id=338268f5&scoped=true&"
import script from "./QuitPageDialog.vue?vue&type=script&lang=js&"
export * from "./QuitPageDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338268f5",
  null
  
)

export default component.exports